import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'WatchNowModal' };

import BuyBox from '@/components/buybox/BuyBox.vue';
import BaseModal from '@/components/modals/BaseModal.vue';

import { WatchlistTitleGraphqlFragment } from '@/components/watchlist/graphql/fragments/WatchlistTitle.fragment';

import { OfferPresentationType } from '@/interfaces/titles';
import type { SponsoredAdFragment } from '@/pages/graphql/fragments/SponsoredAd.fragment';
import { TvShowTrackingTitleFragment } from '@/components/watchlist/graphql/fragments/TVShowTrackingTitle.fragment';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: null,
    defaultPresentationType: null,
    isNextEpisodeButton: { type: Boolean, default: false },
    sponsoredAd: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { title: WatchlistTitleGraphqlFragment['node'] | TvShowTrackingTitleFragment['node'], defaultPresentationType: OfferPresentationType, isNextEpisodeButton: boolean, sponsoredAd: SponsoredAdFragment | undefined };



const titleToDisplay = computed(() => {
	if (props.isNextEpisodeButton && 'watchNextEpisode' in props.title && props.title.watchNextEpisode) {
		return props.title.watchNextEpisode;
	}

	return props.title;
});

const seasonNumber = computed(() => {
	if (titleToDisplay.value.__typename === 'Episode') {
		return titleToDisplay.value?.content.seasonNumber;
	}

	return null;
});

const episodeNumber = computed(() => {
	if (titleToDisplay.value.__typename === 'Episode') {
		return titleToDisplay.value?.content.episodeNumber;
	}

	return null;
});

const headerTitle = computed(() => {
	if (titleToDisplay.value.__typename === 'Episode') {
		return `${titleToDisplay.value?.content.title} - S${seasonNumber.value}E${episodeNumber.value}`;
	}

	return titleToDisplay.value.content.title;
});

const showDetails = computed(() => {
	if (titleToDisplay.value.__typename === 'Episode') {
		return {
			id: props.title.id,
			objectId: props.title.objectId,
			objectType: props.title.objectType,
			title: props.title.content.title,
		};
	}

	return null;
});

const watchlistEntryV2 = ref<{ createdAt: string } | null>(null);
// When a modal is created its lose props references and props are not updating, so we use the flag to be sure that
// prop title is align with GraphQL cache
const isTitleAlignedWithCache = ref(true);

const updatedTitle = computed(() => ({
	...props.title,
	watchlistEntryV2: isTitleAlignedWithCache.value ? props.title.watchlistEntryV2 : watchlistEntryV2.value,
}));

function onWatchlistToggle(createdAt: string | null) {
	isTitleAlignedWithCache.value = false;
	watchlistEntryV2.value = createdAt ? { createdAt } : null;
}

return { __sfc: true,props, titleToDisplay, seasonNumber, episodeNumber, headerTitle, showDetails, watchlistEntryV2, isTitleAlignedWithCache, updatedTitle, onWatchlistToggle, BuyBox, BaseModal }
}

})